import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { RouterMenuProps } from '../configs/route.config'
import { useAuthStore } from '../store/authStore'
import { useDomainManageStore } from '../store/domainManageStore'
import { generateArray } from './store'
import { useLayoutStore } from '../store/layoutStore'

const HeaderTab = () => {
  const [headerMenu] = useState<RouterMenuProps[]>(generateArray())
  const { isSuperUser } = useAuthStore()
  const { pathname } = useLocation()
  const { expandMenu, setExpandMenu } = useLayoutStore()

  const verifyChildLink = (childItem: any) => {
    return childItem.path === pathname || pathname.includes(childItem.path)
  }
  const domainType = useDomainManageStore.getState().domainType
  return (
    <ul
      className={`flex gap-2 text-common text-secondary font-medium header-tab me-auto bg-grey-lightHover lg:p-1 lg:rounded-md flex-col  lg:flex-row absolute lg:static top-[64px] w-full lg:w-auto h-[calc(100vh-64px)] lg:h-auto p-5 max-w-[300px] lg:max-w-max border-r-grey-light border-y-0 border-l-0 border lg:border-none transition-all duration-200  ${expandMenu ? 'left-0' : 'left-[-100%]'}`}
    >
      {headerMenu.map((item) => (
        <>
          {item.isSidebarMenu && item.permission_slugs.includes(domainType) && (
            <Link to={item?.pathOverride ?? (item.path as string)}>
              <li
                key={item.id}
                onClick={() => setExpandMenu(false)}
                className={`py-1 px-2  cursor-pointer hover:text-primary relative rounded-md leading-5 w-fit lg:w-auto  ${verifyChildLink(item) ? 'text-primary drop-shadow-[0_4px_12px_rgba(0,0,0,0.12)] bg-white ' : ''}`}
              >
                {item.label}
              </li>
            </Link>
          )}
        </>
      ))}
      {isSuperUser && (
        <Link to={'/settings'}>
          <li
            className={`py-1 px-2  cursor-pointer hover:text-primary relative rounded-md leading-5  ${verifyChildLink({ path: '/settings' }) ? 'text-primary drop-shadow-[0_4px_12px_rgba(0,0,0,0.12)] bg-white ' : ''}`}
          >
            Settings
          </li>
        </Link>
      )}
    </ul>
  )
}

export default HeaderTab
